import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=52d9b4d0"
import script from "./Spaces.ts?vue&type=script&lang=ts&external"
export * from "./Spaces.ts?vue&type=script&lang=ts&external"
import style0 from "./Spaces.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports